import { createReducer } from '@reduxjs/toolkit';

import {
  REGISTRATIONS_LIST_RESET,
  REGISTRATIONS_LIST_FETCH_START,
  REGISTRATIONS_LIST_FETCH_SUCCESS,
  REGISTRATIONS_LIST_FETCH_FAILURE,
} from './registrationsList.const';

const initialState = {
  model: [],
  meta: {},
};

const registrationsListReducer = createReducer(initialState, builder => {
  builder
    .addCase(REGISTRATIONS_LIST_RESET, () => initialState)
    .addCase(REGISTRATIONS_LIST_FETCH_START, state => {
      state.meta.isLoading = true;
      state.meta.hasError = false;
      state.meta.errorMessage = '';
    })
    .addCase(REGISTRATIONS_LIST_FETCH_SUCCESS, (state, { payload = {} }) => {
      state.model = payload.data;
      state.meta.entityId = payload.entityId;
      state.meta.isLoading = false;
      state.meta.hasError = false;
    })
    .addCase(REGISTRATIONS_LIST_FETCH_FAILURE, (state, { payload = {} }) => {
      state.model = [];
      state.meta.entityId = payload.entityId;
      state.meta.isLoading = false;
      state.meta.hasError = true;
      state.meta.errorMessage = payload.errorMessage;
    })
    .addDefaultCase(() => {});
});

export default registrationsListReducer;
